var render = function render(){var _vm=this,_c=_vm._self._c;return _c('institution-form',{attrs:{"institution":_vm.newIns}})
}
var staticRenderFns = []

export { render, staticRenderFns }